import { useSettings } from "@/context/SettingsContext";

export function Logo({ className = "h-8", withText = true }) {
  const { settings } = useSettings();
  const src = settings?.logo_url || "/takipcisatis-logo.png";
  return <img src={src} alt="TakipciSatis.com" className={className} data-testid="site-logo" loading="eager" />;
}
